export default "__VITE_ASSET__CXMtWuVg__"